/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ExpenseByCategoryReportResponse } from '../models/ExpenseByCategoryReportResponse';
import type { ExpenseRecordResponse } from '../models/ExpenseRecordResponse';
import type { ExpenseSummaryReportResponse } from '../models/ExpenseSummaryReportResponse';
import type { Page_ExpenseRecordResponse_ } from '../models/Page_ExpenseRecordResponse_';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class ExpenseRecordControllerService {
  /**
   * getAllExpenses
   * @returns Page_ExpenseRecordResponse_ OK
   * @throws ApiError
   */
  public static getAllExpensesUsingGet({
    endDate,
    expenseItemId,
    keyword,
    limit = 10,
    maxAmount,
    merchantId,
    minAmount,
    offset,
    staffId,
    startDate,
    subheadId,
    withReceipt,
  }: {
    /**
     * end-date
     */
    endDate?: string;
    /**
     * expense-item-id
     */
    expenseItemId?: string;
    /**
     * keyword
     */
    keyword?: string;
    /**
     * limit
     */
    limit?: number;
    /**
     * max-amount
     */
    maxAmount?: number;
    /**
     * merchant-id
     */
    merchantId?: string;
    /**
     * min-amount
     */
    minAmount?: number;
    /**
     * offset
     */
    offset?: number;
    /**
     * staff-id
     */
    staffId?: string;
    /**
     * start-date
     */
    startDate?: string;
    /**
     * subhead-id
     */
    subheadId?: string;
    /**
     * with-receipt
     */
    withReceipt?: boolean;
  }): CancelablePromise<Page_ExpenseRecordResponse_> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/expenses',
      query: {
        'end-date': endDate,
        'expense-item-id': expenseItemId,
        keyword: keyword,
        limit: limit,
        'max-amount': maxAmount,
        'merchant-id': merchantId,
        'min-amount': minAmount,
        offset: offset,
        'staff-id': staffId,
        'start-date': startDate,
        'subhead-id': subheadId,
        'with-receipt': withReceipt,
      },
      errors: {
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
      },
    });
  }

  /**
   * createExpense
   * @returns ExpenseRecordResponse OK
   * @returns any Created
   * @throws ApiError
   */
  public static createExpenseUsingPost({
    receipt,
  }: {
    receipt?: Blob;
  }): CancelablePromise<ExpenseRecordResponse | any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/expenses',
      formData: {
        receipt: receipt,
      },
      errors: {
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
      },
    });
  }

  /**
   * updateExpense
   * @returns ExpenseRecordResponse OK
   * @returns any Created
   * @throws ApiError
   */
  public static updateExpenseUsingPut({
    receipt,
  }: {
    receipt?: Blob;
  }): CancelablePromise<ExpenseRecordResponse | any> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/expenses',
      formData: {
        receipt: receipt,
      },
      errors: {
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
      },
    });
  }

  /**
   * getExpenseReportByExpenseCategory
   * @returns ExpenseByCategoryReportResponse OK
   * @throws ApiError
   */
  public static getExpenseReportByExpenseCategoryUsingGet({
    endDate,
    startDate,
  }: {
    /**
     * end-date
     */
    endDate?: string;
    /**
     * start-date
     */
    startDate?: string;
  }): CancelablePromise<ExpenseByCategoryReportResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/expenses/reports/by-expense-category',
      query: {
        'end-date': endDate,
        'start-date': startDate,
      },
      errors: {
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
      },
    });
  }

  /**
   * getExpenseSummaryReport
   * @returns ExpenseSummaryReportResponse OK
   * @throws ApiError
   */
  public static getExpenseSummaryReportUsingGet({
    endDate,
    startDate,
  }: {
    /**
     * end-date
     */
    endDate?: string;
    /**
     * start-date
     */
    startDate?: string;
  }): CancelablePromise<ExpenseSummaryReportResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/expenses/reports/summary',
      query: {
        'end-date': endDate,
        'start-date': startDate,
      },
      errors: {
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
      },
    });
  }

  /**
   * deleteExpense
   * @returns any OK
   * @throws ApiError
   */
  public static deleteExpenseUsingDelete({
    id,
  }: {
    /**
     * id
     */
    id: string;
  }): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/expenses/{id}',
      path: {
        id: id,
      },
      errors: {
        401: `Unauthorized`,
        403: `Forbidden`,
      },
    });
  }
}
